let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("3yAl4"), load("lJSD0")]).then(() => parcelRequire('eaE9P'));